// tslint:disable
/**
 * JLIVE ADMIN API
 * JLIVE ADMIN API
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * @export
 * @interface InviteUserRole
 */
export interface InviteUserRole {
  /**
   * @type {number}
   * @memberof InviteUserRole
   */
  user_id: number;
  /**
   * @type {number}
   * @memberof InviteUserRole
   */
  object_id: number;
  /**
   * @type {string}
   * @memberof InviteUserRole
   */
  object_type: InviteUserRoleObjectTypeEnum;
  /**
   * @type {number}
   * @memberof InviteUserRole
   */
  group_id: number;
}

/**
 * @export
 * @enum {string}
 */
export enum InviteUserRoleObjectTypeEnum {
  Event = 'event',
  Organization = 'organization',
}
